<template>
  <el-container class="h-100 w-100 bg-ff">
    <el-main class="flex-column">
      <div class="customerInfo flex align-center justify-space-between">
        <div class="flex align-center">
          <div class="font-18-30313a font-bold">计划提醒</div>
          <div class="line"></div>
          <div>
            <div><span>客户信息：</span>{{info.name}}</div>
            <div><span>装修地址：</span>{{info.detailedAddress}}</div>
          </div>
        </div>
        <div class="close flex align-center justify-center cursor" @click="onClose">
          <i class="el-icon-close font-18-ff"></i>
        </div>
      </div>
      <div class="content flex-column flex-1 bg-f3f4f7 h-0">
        <div class="flex mb-10">
          <div class="title flex align-center bg-ff flex-1 h-0">
            <div class="flex align-center mr-20 cursor" v-for="(item, index) in tab" :key="index" @click="switchTab(index + 1)">
              <div class="mr-5" :class="index + 1 === tabIndex ? 'decoration-line' : 'decoration-line-hui'"></div>
              <div class="font-bold" :class="index + 1 === tabIndex ? 'font-16-f5971d' : 'font-16-30313a'">{{item}}</div>
            </div>
          </div>
        </div>
        <div class="addBtn cursor mb-10" @click="addPlan" v-if="tabIndex === 1">
          <img src="/static/images/customer/chubeikehu.png" alt="">
          <div>新增计划</div>
        </div>
        <div class="flex-1 mb-10 planList h-0">
          <el-scrollbar style="height: 100%;">
            <div class="flex planItem" v-for="(item, index) in planList" :key="index" v-if="tabIndex === 1">
              <div class="flex-1 main">
                <div class="font-12-424142 mb-5"><span>计划内容</span>{{item.content}}</div>
                <div class="font-12-85 mb-2"><span>执行人员</span>{{executorList(item.customerPlanExecutorList)}}</div>
                <div class="font-12-85"><span>提醒时间</span>{{Utils.formatTime2(item.planTime)}}</div>
              </div>
              <div class="w-340 right flex align-center">
                <div class="flex-1 text-center font-12-b9b9b9">{{Utils.formatTime2(item.createTime)}} {{item.foundName}} 创建</div>
                <div class="flex align-center">
                  <button class="btn-16-bg-85 mr-5" @click="toHandle(item)" v-if="item.canExecute">执行</button>
                  <button class="btn-16-bd-ff5555" @click="toDelete(item)">删除</button>
                </div>
              </div>
            </div>
            <div class="finishItem" v-for="(item, index) in planList" :key="index" v-if="tabIndex === 2">
              <div class="flex top">
                <div class="flex-1">
                  <div class="font-12-424142 mb-5"><span>计划内容</span>{{item.content}}</div>
                  <div class="font-12-85 mb-2"><span>执行人员</span>{{executorList(item.customerPlanExecutorList)}}</div>
                  <div class="font-12-85"><span>提醒时间</span>{{Utils.formatTime2(item.planTime)}}</div>
                </div>
                <div class="flex">
                  <div class="flex-1 text-center font-12-b9b9b9">{{Utils.formatTime2(item.createTime)}} {{item.foundName}} 创建</div>
                </div>
              </div>
              <transition name="expand">
                <div class="center" v-show="item.active">
                  <div class="list">
                    <div class="listItem">
                      <div class="font-14-30313a font-bold mb-2">{{item.completorName}}-完成结果：</div>
                      <div class="font-12-b9b9b9 mb-5">{{Utils.formatTime2(item.finishTime)}}</div>
                      <div class="font-12-b9b9b9">{{item.finishContent}}</div>
                    </div>
                  </div>
                </div>
              </transition>
              <div class="bottom">
                <div class="font-12-30313a" @click="onShow(index)"><div>{{item.active ? '收起' : '完成结果'}}</div><i :class="item.active ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="ml-2"></i></div>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
      </div>
    </el-main>
    <!--新增服务计划-->
    <el-dialog title="新增服务计划" :visible.sync="addVisible" width="530px" class="addPlan">
      <div class="p-20">
        <el-form ref="form" :model="add" class="mb-70">
          <el-form-item>
            <div class="flex align-center">
              <div class="font-12-30313a">计划提醒时间：</div>
              <el-date-picker class="flex-1" v-model="add.planTime" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false"></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item v-if="permission === 'selectExecutor'">
            <div class="flex align-center">
              <div class="font-12-30313a">计划执行人员：</div>
              <AddPlanOption ref="employee" :isDepartment="false" :id="id" class="flex-1" v-if="addVisible"></AddPlanOption>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="flex">
              <div class="font-12-30313a">服务计划内容：</div>
              <el-input class="flex-1 font-12-30313a" type="textarea" placeholder="请输入内容" v-model="add.content" maxlength="50" show-word-limit resize="none"></el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <div class="btn-30-bd-85-s mr-10" @click="onCloseAdd">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="onSubmitAdd">确定</div>
      </div>
    </el-dialog>
    <!--执行服务计划-->
    <el-dialog title="执行服务计划" :visible.sync="handleVisible" width="530px" class="handlePlan">
      <div class="p-20">
        <div class="font-12-b9b9b9 text-left mb-10">计划内容：预约客户确定前往公司进行面谈做好资料填写</div>
        <el-form ref="form">
          <el-form-item>
            <div class="flex">
              <div class="font-12-30313a">完成结果：</div>
              <el-input class="flex-1 font-12-30313a" type="textarea" placeholder="请输入内容" v-model="handleContent" resize="none"></el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <div class="btn-30-bd-85-s mr-10" @click="onCloseHandle">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="submitHandle">完成执行</div>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import AddPlanOption from './components/AddPlanOption'
import Pagination from '../../components/Pagination'
export default {
  name: 'planToRemind',
  components: {AddPlanOption, Pagination},
  data () {
    return {
      id: null,
      parent: null,
      info: {},
      tabIndex: 1,
      tab: ['未完成的计划', '已完成的计划'],
      addVisible: false,
      add: {
        planTime: null,
        customerPlanExecutorParamList: [],
        content: ''
      },
      handleVisible: false,
      handleId: null,
      handleContent: null,
      page: 1,
      limit: 10,
      pageSize: 0,
      pageNo: 0,
      pageTotal: 0,
      total: 0,
      planList: [],
      permission: null
    }
  },
  created () {},
  mounted () {
    this.id = this.$route.query.id
    this.parent = this.$route.query.parent
    this.getInfo()
    this.getPlanList()
    this.getPermission()
  },
  methods: {
    getInfo () {
      this.axios.post(`${this.$store.state.API_URL_9010}/customer/getById`, this.qs.stringify({
        id: this.id
      })).then(res => {
        if (res.data.success) {
          this.info = res.data.data
        }
      })
    },
    getPlanList () {
      this.axios.post(`${this.$store.state.API_URL_9010}/customerPlan/queryForPage`, {
        customerId: this.id,
        page: this.page,
        limit: this.limit,
        status: this.tabIndex
      }).then(res => {
        if (res.data.success) {
          this.planList = []
          res.data.data.list.forEach(i => {
            i.active = false
            this.planList.push(i)
          })
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        }
      })
    },
    getPermission () {
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, {
        parent: 'plan',
        parentGroup: 'plan'
      }).then(res => {
        if (res.data.success) {
          this.permission = res.data.data
        }
      })
    },
    executorList (list) {
      let arr = []
      list.forEach(i => {
        arr.push(i.executorName)
      })
      return arr.join('、')
    },
    switchTab (index) {
      this.tabIndex = index
      this.getPlanList()
    },
    addPlan () {
      this.addVisible = true
    },
    onSubmitAdd () {
      // if (this.add.customerPlanExecutorParamList.length === 0) {
      //   this.$message({
      //     message: '请选择计划执行人员',
      //     type: 'warning'
      //   })
      // }
      if (this.add.planTime === null || this.add.planTime === '') {
        this.$message({
          message: '请选择计划提醒时间',
          type: 'warning'
        })
      } else if (this.add.content === null || this.add.content === '') {
        this.$message({
          message: '请输入计划内容',
          type: 'warning'
        })
      } else {
        this.axios.post(`${this.$store.state.API_URL_9010}/customerPlan/save`, {
          customerId: this.id,
          planTime: this.add.planTime,
          content: this.add.content,
          customerPlanExecutorParamList: this.add.customerPlanExecutorParamList
        }).then(res => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.onCloseAdd()
            this.getPlanList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    onCloseAdd () {
      this.addVisible = false
      this.add = {
        planTime: null,
        customerPlanExecutorParamList: [],
        content: ''
      }
    },
    toHandle (item) {
      this.handleVisible = true
      this.handleId = item.id
    },
    submitHandle () {
      if (this.handleContent === null || this.handleContent === '') {
        this.$message({
          message: '请输入完成结果',
          type: 'warning'
        })
      } else {
        this.axios.post(`${this.$store.state.API_URL_9010}/customerPlan/execute`, {
          id: this.handleId,
          finishContent: this.handleContent
        }).then(res => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.onCloseHandle()
            this.getPlanList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    onCloseHandle () {
      this.handleVisible = false
      this.handleContent = ''
    },
    toDelete (item) {
      this.$confirm('此操作将删除该计划, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.post(`${this.$store.state.API_URL_9010}/customerPlan/deleteById`, this.qs.stringify({
          id: item.id
        })).then(res => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.getPlanList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onShow (index) {
      this.planList[index].active = !this.planList[index].active
    },
    onClose () {
      this.$router.go(-1)
    },
    jump (page) {
      this.page = page
      this.getPlanList()
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-main{
    padding: 0;
  }
  .customerInfo{
    width: 100%;
    height: 50px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px
    rgba(0, 0, 0, 0.1);
    font-size: 12px;
    color: #30313a;
    text-align: left;
    padding-left:20px;
    position: relative;
  }
  .close{
    width: 50px;
    height: 50px;
    background: #ff5555;
  }
  .customerInfo span{
    color: #b9b9b9;
  }
  .line{
    height: 32px;
    background: #f3f4f7;
    width: 1px;
    margin: 0 20px;
  }
  .hr{
    width: 100%;
    height: 1px;
    background: #e2e2e2;
    margin: 10px 0;
  }
  .hr-dashed{
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed #e2e2e2;
    margin: 12px 0;
  }
  .content{
    padding: 10px 20px;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .decoration-line-hui{
    width: 4px;
    height: 16px;
    background-color: #e2e2e2;
    border-radius: 4px;
  }
  .content .title{
    height: 30px;
    padding-left: 20px;
    border-radius: 4px;
  }
  .addBtn{
    background: #fff;
    width: 85px;
    height: 24px;
    color: #30313a;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    border-radius: 4px;
  }
  .w-340{
    width: 340px;
  }
  .planList{
    text-align: left;
    overflow-y: auto;
  }
  .planList span{
    font-size: 12px;
    color: #b9b9b9;
    margin-right: 10px;
  }
  .planItem{
    background: #fff;
    border-radius: 4px;
    margin-bottom: 10px;
  }
  .planItem .main{
    padding: 10px;
    border-right: 1px solid #f3f4f7;
  }
  .planItem .right{
    padding: 10px;
  }
  .planList /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .addPlan /deep/ .el-input__prefix{
    left: auto;
    right: 5px;
  }
  .addPlan /deep/ .el-input--prefix .el-input__inner{
    padding-left: 10px;
  }
  .addPlan /deep/ .el-input--prefix .el-input__inner{
    padding-left: 10px;
  }
  .addPlan /deep/ .el-form-item{
    margin-bottom: 10px;
  }
  .addPlan /deep/ .el-textarea__inner{
    padding-left: 10px;
    padding-right: 10px;
    height: 90px;
  }
  .handlePlan /deep/ .el-textarea__inner{
    padding-left: 10px;
    padding-right: 10px;
    height: 240px;
  }
  .finishItem{
    background: #fff;
    border-radius: 4px;
    margin-bottom: 10px;
  }
  .finishItem .top{
    padding: 10px;
  }
  .finishItem .bottom{
    border-top: 1px solid #e2e2e2;
    display: flex;
    justify-content: center;
    padding-bottom: 10px;
  }
  .finishItem .bottom > div{
    width: 80px;
    height: 20px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    background: #e2e2e2;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .finishItem .center{
    border-top: 1px solid #e2e2e2;
  }
  .finishItem .center .list{
    padding:15px;
  }
  .finishItem .center .listItem{
  }
  .expand-enter-active {
    transition: max-height 7s;
    overflow: hidden;
    max-height: 7777px;
  }
  .expand-enter {
    max-height: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/planToRemind.vue